(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/competition/core/tips-sm-makeup.js') >= 0) return;  svs.modules.push('/components/competition/core/tips-sm-makeup.js'); 'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var isServer = (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object';

function makeup(competitionName) {
  if (competitionName === 'TipsSM 2017') {
    return 'Tips-SM 2017';
  }

  return competitionName;
}

if (isServer) {
  module.exports = makeup;
} else {
  svs.competition.core.makeup = makeup;
}
 })(window);